import { createFileRoute } from "@tanstack/react-router";
import { PortalSendersV2Page } from "@/components/v2/pages/portal-senders-v2-page";

export const Route = createFileRoute("/portal/senders/")({
  component: PortalSendersV2Page,
});
